import { render, staticRenderFns } from "./humiture.vue?vue&type=template&id=81300992&scoped=true"
import script from "./humiture.vue?vue&type=script&lang=js"
export * from "./humiture.vue?vue&type=script&lang=js"
import style0 from "./humiture.vue?vue&type=style&index=0&id=81300992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81300992",
  null
  
)

export default component.exports